import { ePEActionsObj } from "../../action-types/tkb/IPEActions";
import { generateActions } from "../generateActions";

export const peActions = {
  ...generateActions(ePEActionsObj, "PE"),
};
